import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import { connect } from "react-redux";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
// Animations
import { mainMenuVariantsAr, mainMenuVariants, curtainVariants, subMenuVariants, subMenuItemVariants, subMenuItemVariantsAr, Variants } from "./animations";
import Trigger from "../../elements/trigger/index.js";
import { gtag } from "../../utils";
// Styles
import "./style.scss";

import { selectHideTrigger } from "../../selectors/application";
import { Icon } from "../../elements";
import SocailMedia from "../../components/Social-Media";

const MobileNavMenu = ({ page, isAR, menuItems = [], newsletter, login, socialItems, onClose, show, user, setIsMenuOpen, forceVisible, scrollDirection, isTriggerHidden, electricImage, fuleImage, hybridImage,phevImage, backText }) => {
	const [showCarModel, setShowCarModel] = useState(false);
	const [carModelData, setCarModelData] = useState([]);
	const [showType, setShowType] = useState(null);
	const [menuItemsData, setMenuItemsData] = useState(menuItems);
  const toggleActiveMenuLevel = (subItems, showType, id, title) => {
		gtag('event', 'L_menu_clk', {
		  'menu_name': title?.value
		});
		let carModelData = [];
		setCarModelData(subItems)
		setShowType(showType?.fields?.phrase?.value)
		if(showType?.fields?.phrase?.value === 'carModel') {
			setShowCarModel(true);
			setIsMenuOpen(false);
		} else {
			let data = JSON.parse(JSON.stringify(menuItemsData));
			data.forEach((item) => {
				if(item.id === id) {
					item.isOpen = !item.isOpen;
				}
			})
			setMenuItemsData(data);
		}
  };
	const toggleMenu = () => {
		if(showCarModel) {
			setShowCarModel(!showCarModel);
			setIsMenuOpen(false)
		}
		if(!showCarModel) {
			setIsMenuOpen(!show)
		}
		if(show || showCarModel) {
			document.body.style.height = 'auto';
			document.body.style.overflowY = 'auto';
		} else {
			document.body.style.height = '100vh';
			document.body.style.overflowY = 'hidden';
		}
	};
	const goBack = () => {
		setShowCarModel(false);
		setIsMenuOpen(true);
	};
	const toDetail = (link) => {
		gtag('event', 'L_menu_clk', {
		  'menu_name': link?.value?.href,
		});
		setShowCarModel(false);
		document.body.style.height = '100vh';
		document.body.style.overflowY = 'auto';
	};
  return (
    <>
      <div
        className={classNames("trigger-container", {
          hide: (!forceVisible && scrollDirection === "down" && !show) || isTriggerHidden
        })}
      >
        <Trigger isMenuOpen={show || showCarModel} onClick={() => toggleMenu()} />
      </div>
      <AnimatePresence>
        {show && (
          <div className="container">
            <div className={classNames("mobile-nav-menu", { active: show })}>
              <div className="trigger-menu" />
              <motion.div className="curtain" variants={curtainVariants} initial="hidden" exit="hidden" animate="visible">
                <motion.ul className="main-menu" variants={isAR ? mainMenuVariantsAr : mainMenuVariants}>
                  {menuItemsData.map(({ id, isOpen, fields: { link, title= [], subTitles = [], carCode={}, showType={} } }) => (
                    <li key={link.value.href}>
                      <MenuItem {...{ page, link, title, subTitles, carCode, isAR, showType, id, isOpen }} onLinkClick={link => onClose(link)} onIconClick={(subTitles, showType, id, title) => toggleActiveMenuLevel(subTitles, showType, id, title)} showIcon={!!subTitles.length} />
                    </li>
                  ))}
                </motion.ul>
              </motion.div>
            </div>
          </div>
        )}
      </AnimatePresence>
			<AnimatePresence>
				{showCarModel && <motion.div className={classNames("carmodel", showType === "carModel" ? 'active' : '')} variants={isAR ? mainMenuVariantsAr : mainMenuVariants} initial="hidden" exit="hidden" animate="visible">
					<div className="carmodel_back" onClick={(e) => goBack(e)}>
						{!isAR && <Icon name="ArrowLeft" />}
						{isAR && <Icon name="ArrowRight" />}
						<RichText className="carmodel_back_text" tag="div" field={backText} />
					</div>
					<div className="carmodel_detail">
						{carModelData?.length && carModelData.map((item, index) => {
							return (
								<div className="carmodel_item" key={index}>
									{item?.fields?.carModelImage?.value?.src && <img className="carmodel_item_title" src={item?.fields?.carModelImage?.value?.src} />}
									{showType !== "carModel" && item?.fields?.carModelName?.value && <RichText className="carmodel_item_title_txet" tag="div" field={item?.fields?.carModelName} />}
									<div className="carmodel_item_carcontent">
										{item?.fields?.subItems?.length && item?.fields?.subItems?.map((el, i) => {
											return (
												<NavLink to={el?.fields?.link?.value?.href} className={classNames("carmodel_item_content", i > 2 ? 'current' : '')} id={i} key={el.id} onClick={(e) => toDetail(el?.fields?.link)}>
													{el?.fields?.carImage?.value?.src && <img className="carmodel_item_content_carimage" src={el?.fields?.carImage?.value?.src} />}
													{showType === "carModel" && el?.fields?.carName?.value && <RichText className="carmodel_item_content_carname" tag="div" field={el?.fields?.carName} />}
													{showType === "carModel" && <div className="carmodel_item_content_cartype">
														{el?.fields?.carType?.fields?.key?.value === "electric" && <img className="carmodel_item_content_cartype_img" src={electricImage?.value?.src} />}
														{el?.fields?.carType?.fields?.key?.value === "fuel" && <img className="carmodel_item_content_cartype_img" src={fuleImage?.value?.src} />}
														{el?.fields?.carType?.fields?.key?.value === "hybrid" && <img className="carmodel_item_content_cartype_img" src={hybridImage?.value?.src} />}
														{el?.fields?.carType?.fields?.key?.value === "Phev" && <img className="carmodel_item_content_cartype_img" src={phevImage?.value?.src} />}
														{el?.fields?.carType?.fields?.phrase?.value && <RichText className={classNames("carmodel_item_content_cartype_name", `theme-${el?.fields?.carType?.fields?.key?.value}`)} tag="div" field={el?.fields?.carType?.fields?.phrase} />}
													</div>}
													{showType === "carModel" && <div className="carmodel_item_content_cartype_link">
														<div className="carmodel_item_content_cartype_link_text">{el?.fields?.link?.value?.text}</div>
														{!isAR && <Icon name="ArrowRight" />}
														{isAR && <Icon name="ArrowLeft" />}
													</div>}
												</NavLink>
											)
										})}
									</div>
								</div>
							);
						})}
					</div>
				</motion.div>}
			</AnimatePresence>
    </>
  );
};

const mapStateToProps = state => {
  return {
    isTriggerHidden: selectHideTrigger(state)
  };
};

export default connect(mapStateToProps, null)(MobileNavMenu);

const MenuItem = ({ page, link, title, subTitles, showType, className, isAR, isOpen, id, showIcon = false, isActive = false, carCode = {}, onLinkClick = () => {}, onIconClick = () => {} }) => (
  <div className={classNames("nav-link", className)}>
    {link.value.linktype === "internal" ? (
       page?.fields?.CarModel?.fields?.code?.value && carCode?.value == true ?
       (
        <NavLink to={link.value.href+'?car='+encodeURIComponent(page.fields.CarModel.fields.code.value)} activeClassName="active" onClick={onLinkClick}>
          {link.value.text}
        </NavLink>
       ):(
        <NavLink to={link.value.href} activeClassName="active" onClick={() => onLinkClick(link)} className={[(link.value.id.toLowerCase()).indexOf(page?.itemId) === -1 ? '' : 'active1'].join(' ')}>
          {link.value.text}
        </NavLink>
       )
    ) : 
    link.value.href === "" ? (
      <div className="menu-title" onClick={() => onIconClick(subTitles, showType, id, title)}>
				<div className="menu-title-content">
					<div className={[isOpen ? 'active' : ''].join(' ')}>{title.value}</div>
					{showIcon && !isAR && showType?.fields?.phrase?.value !== 'carModel' && (
						<Icon name="ArrowRight" className={classNames({ rotate: isOpen })} onClick={() => onIconClick(subTitles, showType, id, title)} />
					)}
					{showIcon && isAR && showType?.fields?.phrase?.value !== 'carModel' && (
						<Icon name="ArrowLeft" className={classNames({ rotate: isOpen })} onClick={() => onIconClick(subTitles, showType, id, title)} />
					)}
				</div>
				<AnimatePresence>
					{showType?.fields?.phrase?.value !== 'carModel' && isOpen && <motion.div className="submenu" variants={isAR ? mainMenuVariantsAr : mainMenuVariants} initial="hidden" exit="hidden" animate="visible">
						{subTitles && subTitles?.map((el, i) => {
							return (
								<a key={i} target={el?.fields?.link?.value?.target} href={el.fields.link.value.href} activeClassName="active" onClick={() => onLinkClick(el.fields.link)} className={[el?.fields?.link?.value?.id && (el?.fields?.link?.value?.id?.toLowerCase())?.indexOf(page?.itemId) !== -1 ? 'active' : ''].join(' ')}>
									{el.fields.carModelName.value}
								</a>
							)
						})}
					</motion.div>}
				</AnimatePresence>
			</div>
    ):
    (
      <a href={link.value.href} target="_blank" rel="noopener noreferrer" onClick={() => onLinkClick(link)}>
        {link.value.text}
      </a>
    )}
    {showIcon && !isAR && showType?.fields?.phrase?.value === 'carModel' && (
			<Icon name="ArrowRight" className={classNames({ active: isActive })} onClick={() => onIconClick(subTitles, showType, id, title)} />
		)}
		{showIcon && isAR && showType?.fields?.phrase?.value === 'carModel' && (
			<Icon name="ArrowLeft" className={classNames({ active: isActive })} onClick={() => onIconClick(subTitles, showType, id, title)} />
		)}
  </div>
);
